import { render, staticRenderFns } from "./ObservacionRelator.vue?vue&type=template&id=7d84679a&"
import script from "./ObservacionRelator.vue?vue&type=script&lang=js&"
export * from "./ObservacionRelator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports